module.exports = __webpack_public_path__ + "media/images/home/notebook@2x-cfc61be95012437b33ef3404b6c2e393.png";